// Top 100 Philippine peaks by elevation, from Wikipedia's "List of mountains in the Philippines" (CC BY-SA).
// Trail class uses the Pinoy Mountaineer 1–9 scale; only well-known peaks are rated — confirm with the Climbs Committee.
export const topMountainColumns = ['#', 'Mountain', 'Province(s)', 'Elevation', 'Type', 'Trail class'];

export const topMountains: string[][] = [
  ['1', 'Mt. Apo', 'Davao del Sur, Cotabato', '2,954 MASL', 'Major', '7/9'],
  ['2', 'Mt. Dulangdulang', 'Bukidnon', '2,938 MASL', 'Major', '6/9'],
  ['3', 'Mt. Pulag', 'Ifugao, Benguet, Nueva Vizcaya', '2,922 MASL', 'Major', '3/9 (Ambangeg) · 7/9 (Akiki)'],
  ['4', 'Mt. Ragang (Piapayungan)', 'Lanao del Sur', '2,894 MASL', '—', '—'],
  ['5', 'Mt. Kalatungan', 'Bukidnon', '2,824 MASL', 'Major', '6/9'],
  ['6', 'Mt. Tabayoc', 'Ifugao', '2,820 MASL', 'Major', '5/9'],
  ['7', 'Mt. Maagnaw', 'Bukidnon', '2,742 MASL', '—', '—'],
  ['8', 'Mt. Mongoto', 'Benguet', '2,719 MASL', '—', '—'],
  ['9', 'Mt. Timbak', 'Benguet', '2,717 MASL', 'Minor', '2/9'],
  ['10', 'Mt. Kalawitan', 'Ifugao', '2,713 MASL', '—', '—'],
  ['11', 'Mt. Kapiligan', 'Ifugao', '2,709 MASL', '—', '—'],
  ['12', 'Mt. Tuminungan', 'Bukidnon', '2,706 MASL', '—', '—'],
  ['13', 'Mt. Amuyao', 'Mountain Province', '2,701 MASL', 'Major', '6/9'],
  ['14', 'Mt. Talomo', 'Davao / Cotabato', '2,674 MASL', '—', '—'],
  ['15', 'Mt. Tagubud', 'Davao de Oro', '2,670 MASL', '—', '—'],
  ['16', 'Mt. Al-al', 'Benguet', '2,663 MASL', '—', '—'],
  ['17', 'Mt. Abao', 'Ifugao', '2,662 MASL', '—', '—'],
  ['18', 'Mt. Osdung (Osdong)', 'Benguet', '2,615 MASL', '—', '—'],
  ['19', 'Mt. Lumuluyaw', 'Bukidnon', '2,612 MASL', '—', '—'],
  ['20', 'Mt. Napulauan', 'Ifugao', '2,611 MASL', 'Major', '6/9'],
  ['21', 'Mt. Halcon', 'Oriental Mindoro', '2,582 MASL', 'Major', '9/9'],
  ['22', 'Mt. Nangaoto', 'Benguet', '2,553 MASL', '—', '—'],
  ['23', 'Mt. Baco', 'Occidental Mindoro', '2,489 MASL', '—', '—'],
  ['24', 'Mt. Mangabon', 'Misamis Oriental', '2,480 MASL', '—', '—'],
  ['25', 'Kanlaon Volcano (Mount Canlaon)', 'Negros Oriental, Negros Occidental', '2,465 MASL', 'Major', '7/9'],
  ['26', 'Mayon Volcano', 'Albay', '2,460 MASL', 'Restricted', '—'],
  ['27', 'Mt. Pawoi', 'Benguet / Mountain Province', '2,456 MASL', '—', '—'],
  ['28', 'Mt. Balbalasang', 'Abra, Kalinga', '2,454 MASL', '—', '—'],
  ['29', 'Mt. Balatukan (Balatucan)', 'Misamis Oriental', '2,450 MASL', '—', '—'],
  ['30', 'Mt. Malindang', 'Misamis Occidental', '2,425 MASL', 'Major', '6/9'],
  ['31', 'Mt. Sicapoo', 'Abra, Ilocos Norte', '2,360 MASL', '—', '—'],
  ['32', 'Mt. Palugloko', 'Ifugao', '2,356 MASL', '—', '—'],
  ['33', 'Latukan Volcano', 'Lanao del Sur', '2,338 MASL', '—', '—'],
  ['34', 'Mt. Namidraan', 'Ilocos Sur', '2,334 MASL', '—', '—'],
  ['35', 'Mt. Ambalatungan', 'Kalinga', '2,329 MASL', '—', '—'],
  ['36', 'Mt. Binuluan', 'Kalinga', '2,329 MASL', '—', '—'],
  ['37', 'Mt. Kilakron', 'South Cotabato', '2,329 MASL', '—', '—'],
  ['38', 'Mt. Sumagaya', 'Misamis Oriental', '2,320 MASL', '—', '—'],
  ['39', 'Mt. Locoono', 'Mountain Province', '2,316 MASL', '—', '—'],
  ['40', 'Mt. Data', 'Mountain Province, Benguet', '2,310 MASL', '—', '—'],
  ['41', 'Mt. Pack', 'Nueva Vizcaya', '2,294 MASL', '—', '—'],
  ['42', 'Mt. Matutum (Matutum Volcano)', 'South Cotabato', '2,286 MASL', 'Minor', '4/9'],
  ['43', 'Mt. Camingingel', 'Ilocos Sur, Abra, Mountain Province', '2,283 MASL', '—', '—'],
  ['44', 'Mt. Sipitan', 'Mountain Province', '2,283 MASL', '—', '—'],
  ['45', 'Mt. Candalaga', 'Davao de Oro', '2,268 MASL', '—', '—'],
  ['46', 'Mt. Mengmeng (Menmeng)', 'Mountain Province, Abra', '2,263 MASL', '—', '—'],
  ['47', 'Mt. Kampalili', 'Davao', '2,257 MASL', '—', '—'],
  ['48', 'Mt. Santo Tomas', 'Benguet', '2,251 MASL', 'Minor', '3/9'],
  ['49', 'Mt. Muskut', 'Kalinga', '2,223 MASL', '—', '—'],
  ['50', 'Mt. Balait', 'Apayao, Abra', '2,200 MASL', '—', '—'],
  ['51', 'Mt. Banahaw (Banahao)', 'Laguna, Quezon', '2,177 MASL', 'Major', '5/9'],
  ['52', 'Mt. Lobo', 'Benguet', '2,156 MASL', '—', '—'],
  ['53', 'Mt. Kaatoan', 'Bukidnon', '2,153 MASL', '—', '—'],
  ['54', 'Makawiwili Peak', 'Negros Occidental', '2,141 MASL', '—', '—'],
  ['55', 'Mt. Paquis', 'Mountain Province', '2,140 MASL', '—', '—'],
  ['56', 'Mt. Puguis', 'Mountain Province', '2,140 MASL', '—', '—'],
  ['57', 'Mt. Lamagan', 'Mountain Province', '2,138 MASL', '—', '—'],
  ['58', 'Mt. Burnay', 'Ilocos Norte / Abra', '2,115 MASL', '—', '—'],
  ['59', 'Mt. Caual', 'Benguet, Nueva Vizcaya', '2,105 MASL', '—', '—'],
  ['60', 'Mt. Ugu', 'Nueva Vizcaya', '2,090 MASL', 'Major', '5/9'],
  ['61', 'Mt. Mantalingajan (Mantaling)', 'Palawan', '2,085 MASL', '—', '—'],
  ['62', 'Mt. Bosa', 'South Cotabato', '2,083 MASL', '—', '—'],
  ['63', 'Mt. Guiting-Guiting (Guitinguitin)', 'Romblon', '2,051 MASL', 'Major', '9/9'],
  ['64', 'Mt. Tapulao (High Peak)', 'Zambales', '2,037 MASL', 'Major', '5/9'],
  ['65', 'Mt. Busa', 'Sarangani, South Cotabato', '2,030 MASL', '—', '—'],
  ['66', 'Mt. Chumanchil', 'Kalinga', '2,029 MASL', '—', '—'],
  ['67', 'Mt. Licod-ti-Duyog', 'Apayao', '2,024 MASL', '—', '—'],
  ['68', 'Mt. Manmanoc', 'Abra', '2,024 MASL', '—', '—'],
  ['69', 'Mt. Palansa', 'Benguet / Mountain Province', '2,001 MASL', '—', '—'],
  ['70', 'Mt. Isarog', 'Camarines Sur', '1,976 MASL', 'Major', '6/9'],
  ['71', 'Mt. Tinadagan (Tinadanan)', 'Mountain Province', '1,969 MASL', '—', '—'],
  ['72', 'Mt. Wood', 'Oriental Mindoro', '1,960 MASL', '—', '—'],
  ['73', 'Mt. Pamalihi', 'Misamis Oriental', '1,956 MASL', '—', '—'],
  ['74', 'Mt. Bintuod', 'Nueva Vizcaya', '1,935 MASL', '—', '—'],
  ['75', 'Mt. Makaturing', 'Lanao del Sur', '1,908 MASL', '—', '—'],
  ['76', 'Cuernos de Negros (Talinis Peak)', 'Negros Oriental', '1,903 MASL', '—', '—'],
  ['77', 'Mingan Mountains', 'Aurora', '1,901 MASL', '—', '—'],
  ['78', 'Mt. Oyayao', 'Mountain Province', '1,898 MASL', '—', '—'],
  ['79', 'Mt. Polis', 'Ifugao', '1,895 MASL', '—', '—'],
  ['80', 'Mt. Mandalagan', 'Negros Occidental', '1,885 MASL', '—', '—'],
  ['81', 'Banahao de Lucban', 'Quezon, Laguna', '1,875 MASL', '—', '—'],
  ['82', 'Mt. Calabugao', 'Bukidnon', '1,864 MASL', '—', '—'],
  ['83', 'Mt. Mabaho', 'Agusan del Norte', '1,860 MASL', '—', '—'],
  ['84', 'Mt. Maranat', 'Lanao, Bukidnon', '1,858 MASL', '—', '—'],
  ['85', 'Mt. Anacuao', 'Aurora, Quezon', '1,852 MASL', '—', '—'],
  ['86', 'Mt. Patoc', 'Mountain Province', '1,850 MASL', '—', '—'],
  ['87', 'Mt. Hilonghilong', 'Agusan del Norte', '1,838 MASL', '—', '—'],
  ['88', 'Mt. Cetaceo', 'Cagayan', '1,833 MASL', '—', '—'],
  ['89', 'Mt. Ticmo', 'Abra', '1,826 MASL', '—', '—'],
  ['90', 'Mt. Gurain', 'Lanao', '1,825 MASL', '—', '—'],
  ['91', 'Mt. Bacauan', 'Zamboanga del Sur', '1,824 MASL', '—', '—'],
  ['92', 'Mt. Guinsayawan (Tipasi, Tepasi)', 'Negros Oriental', '1,821 MASL', '—', '—'],
  ['93', 'Kioto Mountains', 'Davao Occidental', '1,816 MASL', '—', '—'],
  ['94', 'Peak 2', 'Nueva Ecija', '1,812 MASL', '—', '—'],
  ['95', 'Saw Tooth Mountain', 'Zambales, Tarlac', '1,806 MASL', '—', '—'],
  ['96', 'Mt. Binmaca', 'Ilocos Sur, Mountain Province, Benguet', '1,787 MASL', '—', '—'],
  ['97', 'Thumb Peak', 'Palawan', '1,787 MASL', '—', '—'],
  ['98', 'Mt. Aganmala', 'Ilocos Norte', '1,786 MASL', '—', '—'],
  ['99', 'Mt. Nagdubaduban (Nagdabbaduban)', 'Ilocos Norte', '1,786 MASL', '—', '—'],
  ['100', 'Mt. Gantung', 'Palawan', '1,784 MASL', '—', '—'],
];
